export default __webpack_public_path__ + "static/blobfiled-61103595369139b667c112aa6e6e0b10.png";